import { getCart, updateItem as cartUpdateItem, changeItem as cartChangeItem } from './methods';
import { listen, dispatch } from '@city-mattress/js-utils';
import type { TAddToCartPayload, TCart } from '../../../types/cart';

import { EVENTS as CartEvents, CartEventBus } from './bootstrap';


const addToCartHandler = async function (detail: TAddToCartPayload) {
	if(Array.isArray(detail) && detail.length > 0) { 

		let cartUrl = `${window['Shopify'].routes.root}cart/add.js`;
		let formData = {
			items: detail
		};

		//notify the app before adding to the cart
		dispatch(CartEvents.BEFORE_ADD_TO_CART, formData);

		return fetch(cartUrl, {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		  })
		  .then(response => {
			return response.json();
		  })
		  .then((jsonResponse) : TCart => {
			dispatch(CartEvents.AFTER_ADD_TO_CART);
			return jsonResponse;
		  })
		  .catch((error) => {
			console.error('Error:', error);
		  });
	}
	else {
		return new Promise((resolve) => {
			resolve(null);
		});
	}
};


export default (Alpine) => {
	Alpine.store('shopifyCart', {
		get items() {
			return this.cart !== null ? this.cart.items : [];
		},
		get count() {
			return this.cart !== null ? this.cart.item_count : 0;
		},
		isLoading: false,
		cart: null,
	
		/**
		 * Update the quantity of an item in the cart, can be used to remove by passing 0
		 * @param lineItemKey 
		 * @param quantity 
		 */
		updateItem(lineItemKey: string, quantity: number) {
			this.isLoading = true;			
			cartChangeItem({ id: lineItemKey, quantity: quantity }).then(() => {
				CartEventBus.publish(CartEvents.UPDATE_RENDER);
				this.refreshCart().then(() => {
					this.isLoading = false;
				});
				
			});
		},
		async refreshCart() {
			return getCart().then((cart) => {
				this.cart = {... cart };
				return this.cart;
			});
		},
		init() {		
			/**
			 * Listen for our add to cart event and process the cart payload
			 */
			listen(CartEvents.ADD_TO_CART, (eventPayload: CustomEvent<TAddToCartPayload>) => {
				const { detail }: { detail: TAddToCartPayload } = eventPayload;
				addToCartHandler(detail).then(async (addedItemResponse: TCart | null) => {
					if(addedItemResponse !== null) {
						dispatch(CartEvents.ADDED_TO_CART, addedItemResponse);
						this.refreshCart().then(() => {
							CartEventBus.publish(CartEvents.UPDATE_RENDER);
						});
						
					}
				});
			});
	
			//Cart set on our CM object, grab it to avoid an extra API call
			if(window['CM'].shopifyCart) {
				this.cart = {...window['CM'].shopifyCart };
			}
			else {
				this.isLoading = true;
				this.refreshCart().then(() => {
					this.isLoading = false;
				});
			}
		}
	});
};